export enum MainContactPositionForEntryForm {
  CSuiteOrPresident = 'C-Suite, President / VP',
  FinanceManager = 'Finance Manager',
  SalesManager = 'Sales Manager',
  Salesperson = 'Salesperson',
  Employee = 'Employee',
}

export enum EntryFormResultStatus {
  New = 'New',
  PendingUser = 'PendingUser',
  DisabledUser = 'DisabledUser',
  ExistingIntermediary = 'ExistingIntermediary',
  RejectedIntermediary = 'RejectedIntermediary',
  Active = 'Active',
}

export enum ExpiredSessionPageType {
  Login = 'Login',
  SendEmail = 'SendEmail',
}
